import PublicActivityType from '@/pages/publicPages/PublicActivityType/PublicActivityType';
import PublicActivityTypeSSP from '@/pages/publicPages/PublicActivityType/PublicActivityType.ssp';
import PageSEO from '@/shared/PageSEO/PageSEO';

export default function InteractiveVideos(props) {
  return (
    <>
      <PageSEO title="Interactive Spanish Videos for Kids – Fun Learning Activities | Rockalingua" />
      <PublicActivityType {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivityTypeSSP({ context, activityType: 'interactiveVideo' });
